module.exports = __webpack_public_path__ + "img/symbol_1.3f448ecf.png";